<!--
 * @Author: wangwenshuai 644586996@qq.com
 * @Date: 2022-08-12 09:33:10
 * @LastEditors: wangwenshuai 644586996@qq.com
 * @LastEditTime: 2023-11-10 14:16:50
 * @FilePath: \dbarsdgs\src\components\DataServer\Statistics\DataStatistics.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="DataStatistics">
    <Title :Msg="titMsg"></Title>
    <div class="DataStatistics_box">
      <div class="DataStatistics_box_row">
        <div class="DataStatistics_box_row_div">
          <p>{{$t('DataServer.dataVolume')}}</p>
          <countTo class="num" :startVal='startVal' :endVal='var1' suffix="PB" :decimals='decimals' :duration='3000'></countTo>
        </div>
        <div class="hr"></div>
        <div class="DataStatistics_box_row_div">
          <p>{{$t('DataServer.numberfiles')}}</p>
          <!-- StatisticsData.totalFile -->
          <countTo class="num" :startVal='startVal' :endVal='totalFile' :duration='3000'></countTo>
        </div>
      </div>
      <div class="DataStatistics_box_row">
        <div class="DataStatistics_box_row_div" >
          <p>{{$t('DataServer.views')}}</p>
            <countTo v-if="StatisticsData" class="num" :startVal='startVal' :endVal='StatisticsData.visits' :duration='3000'></countTo>
        </div>
        <div class="hr"></div>
        <div class="DataStatistics_box_row_div">
          <p>{{$t('DataServer.downloads')}}</p>
            <countTo class="num" v-if="StatisticsData" :startVal='startVal' :endVal='StatisticsData.downloads' :duration='3000'></countTo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
export default {
    props:['StatisticsData'],
  data() {
    return {
      startVal: 0,
      var1: 1.20,
      var2: 14,
      var3: 94966114,
      var4: 1152056,
      totalFile:1143905,
      decimals:2
    };
  },
  computed:{
    titMsg:function(){
      return this.$t('DataServer.platformStatistics')
    }
  },
  components: {
    countTo,
    Title: () => import("@/components/DataServer/Statistics/Title.vue"),
  },
};
</script>

<style lang="scss" scoped>
.DataStatistics {
  background: #fff;

  .DataStatistics_box {
    display: flex;
    flex-direction: column;
    .DataStatistics_box_row {
      display: flex;
      flex-direction: row;
      align-items: center;
      // height: 66px;
      // margin-bottom: 10px;
      .hr {
        width: 1px;
        height: 36px;
        background: #ebebeb;
      }
      .DataStatistics_box_row_div {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p {
          margin-top: 10px;
          padding: 0 4px;
          margin-bottom: 6px;
          color: #999;
          font-size: 12px;
          text-align: center;
        }
        .num {
          font-weight: 600;
          color: #333333;
          font-size: 18px;
        }
      }
    }
  }
}
</style>